import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { User } from 'src/app/front-user/shared/models/user.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { Router } from '@angular/router';
import { AppConfig } from 'src/app/shared/services/app.config';
import { RegisterType, Languages } from 'src/app/shared/models/enums.model';
import { PasswordStrengthValidator } from '../../shared/validator/password-strength.validators';
import { UserService } from '../../shared/services/user.service';
import { RegistrationType } from '../../shipyard-service/models/register-type.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { CustomValidators } from '../../shipyard-service/models/custom-validator';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  loading = false;
  submitted = false;
  user: User = new User();
  responseObject: ResponseObject;
  loginError: any;
  sitekey = AppConfig.settings.apiServer.captchaSiteKey;
  counter = 0;
  showRequest = false;
  isAgent = false;
  private isSupplierAllowedtoResendConfirmMail: boolean = false;
  emailRegex = '^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+(\\.)[a-zA-Z0-9-.]+$';
  displayedLang: Languages;
  lang = 'en';
  constructor(private formBuilder: FormBuilder,
    private alertService: AlertService,
    private authService: AuthenticationService,
    private router: Router,
    private userSrv: UserService,
    private globalSrv: GlobalServices,
    private translate: TranslateService, ) {
    this.displayedLang = this.globalSrv.getLanguage();
    if (this.displayedLang == Languages.Arabic) {
      this.lang = 'ar';
    } else {
      this.lang = 'en';
    }

    if (this.authService.currentUserValue) {
      //this.globalSrv.goToHome();
    }
  }

  ngOnInit() {
    this.buildForm();
  }
  buildForm() {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.pattern(this.emailRegex), CustomValidators.textSpaceValidator()]],
      password: ['', [Validators.required]],
      recaptcha: [undefined]
    });

  }
  get f() {
    return this.loginForm.controls;
  }


  onSubmit() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    this.loading = true;
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.user.UserName = this.loginForm.controls.username.value;
    this.user.Password = this.loginForm.controls.password.value;
    this.user.Password = this.globalSrv.encryptPassword(this.user.Password.trim());
    if (this.counter > AppConfig.settings.apiServer.LoginTries) {
      this.userSrv.RemoveLock(this.user.UserName)
        .subscribe((data: ResponseObject) => {
          if (!data.Success) {
            this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + this.responseObject.ErrorMessages[0]));
            this.loading = false;
          }
        });
    }
    setTimeout(() => {
      this.authService.login(this.user)
        .pipe(first())
        .subscribe(
          (data: ResponseObject) => {
            this.responseObject = data;
            if (this.responseObject.Success) {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              if (this.responseObject.Data.RegisterTypeId == RegisterType.PortalUser) {
                if (!this.responseObject.Data.IsConfirmed) {
                  this.router.navigate(['/userprofile']);
                  this.loading = false;
                } else {
                  this.router.navigate(['/workspace']);
                  this.loading = false;
                }
              } else if (this.responseObject.Data.RegisterTypeId == RegisterType.Agent) {
                if (this.responseObject.Data.IsExpiredDueCertificate) {
                  this.router.navigate(['/updateAgentProfile']);
                } else {
                  this.router.navigate(['/workspace']);
                  this.loading = false;
                }
              } else if (this.responseObject.Data.RegisterTypeId == RegisterType.Supplier) {
                this.router.navigate(['/workspace']);
                this.loading = false;
              } else {
                this.router.navigate(['/myTasks']);
                this.loading = false;
              }

            } else {
              this.counter = this.counter + 1;
              this.isAgent = this.responseObject.ErrorMessages.find(e => e == 'Agent') != null ? true : false;
              this.isSupplierAllowedtoResendConfirmMail = this.responseObject.ErrorMessages.find(e => e == "SupplierAllowedtoResendConfirmMail") != null ? true : false;
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = false;
              this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + this.responseObject.ErrorMessages[0]), false);
              this.loading = false;
              this.loginError = this.responseObject.ErrorMessages[0];
            }

          });
    }, 300);
  }

  checkstate() {
    if (this.counter > AppConfig.settings.apiServer.LoginTries) {
      this.loginForm.get('recaptcha').setValidators(Validators.required);
    } else {
      this.loginForm.get('recaptcha').clearValidators();
    }
    this.loginForm.get('recaptcha').updateValueAndValidity();
  }

  ResendActivation() {
    this.alertService.clear();
    this.userSrv.ResendAgentActivation(this.user.UserName)
      .subscribe((data: ResponseObject) => {
        if (!data.Success) {
          this.alertService.error(this.translate.instant('FRONT_USER.LOGIN_FORM.EMAIL_ERROR'));
          this.loading = false;
        } else {
          this.showRequest = true;
        }
      });
  }

  ResendSupplierActivation() {
    this.alertService.clear();
    this.userSrv.ResendSupplierActivation(this.user.UserName)
      .subscribe((data: ResponseObject) => {
        if (!data.Success) {
          this.alertService.error(this.translate.instant('FRONT_USER.LOGIN_FORM.EMAIL_ERROR'));
          this.loading = false;
        } else {
          this.showRequest = true;
        }
      });
  }

}
